// ActionCable consumer
// @ts-ignore - ActionCable is provided globally by Rails
import { createConsumer } from "@rails/actioncable"

export default createConsumer()
